const validate = (value, args) => {
  if (!value) {
    return true
  }
  var localPart = value.substring(0, value.indexOf('@'))
  // Only .-_&+ special chars in local part. Also " and space.
  // eslint-disable-next-line
  let regex = /[^0-9a-zA-Z\.\-_&\+ "]+/
  return !regex.test(localPart)
}

export default {
  validate,
  getMessage: (field, args) => {
    return 'The accents are not allowed'
  }
}
